import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, showDeleteDialog, Text, useSettings } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

export default function PhonesModuleListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings(props.model.phon_table);

	const editPhone = () => {
		dispatch(
			showFastAddDialog({
				module: 'phones',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh
			})
		);
	};

	const deletePhone = () =>
		dispatch(
			showDeleteDialog({
				module: 'phones',
				id: props.model.phon_uid,
				title: props.model.phon_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			<IconButton onClick={editPhone}>
				<Icon icon="pencil" />
			</IconButton>
			<IconButton onClick={deletePhone} edge="end">
				<Icon icon="delete" />
			</IconButton>
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.phon_warning_desc && (
								<Tooltip title={props.model.phon_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.phon_blocked_desc && (
								<Tooltip title={props.model.phon_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* DEFAULT */}
							{props.model.phon_default && (
								<Tooltip title={t('DEFAULT_ITEM')} arrow>
									<Icon className="mr-2" icon="label-variant" />
								</Tooltip>
							)}
							{/* DESCRIPTION */}
							<Text className="font-600" variant="subtitle2">
								{props.model.phon_description || t('MODULE_PHONES_NAME_SINGULAR')}
							</Text>
						</Grid>
						<Grid size={12}>
							{/* PHONE NUMBER */}
							<ButtonLink href={`tel:${props.model.phon_title}`}>{props.model.phon_title}</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container alignItems="center" spacing={1}>
						{/* LINKED PERSON */}
						{props.model.peop_uid && (
							<Grid>
								<ButtonLink
									href={`/people/details/${props.model.peop_uid}`}
									icon="card-account-details-outline"
								>
									{props.model.peop_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED COMPANY */}
						{props.model.comp_uid && (
							<Grid>
								<ButtonLink href={`/companies/details/${props.model.comp_uid}`} icon="domain">
									{props.model.comp_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED USER */}
						{props.model.user_uid && (
							<Grid>
								<ButtonLink href={`/users/details/${props.model.user_uid}`} icon="account-circle">
									{props.model.user_title}
								</ButtonLink>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
